/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Chevron Forward Icon component.
 */
const ChevronForwardIcon = ({color = dlsColor('grey3')}: IconProps) => {
  const {iconColor} = useIconDLS({color});
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_21160_96113)'>
        <path fillRule='evenodd' clipRule='evenodd' d='M2.85 9.45L3.87162 10.5L8.25 6L3.87162 1.5L2.85 2.55L6.20676 6L2.85 9.45Z' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_21160_96113'>
          <rect width='12' height='12' fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default React.memo(ChevronForwardIcon);
